import React from 'react';
import { IconBase } from '../Base';
export const IconCross = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M13.5355 6.46448L6.46445 13.5355", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } }),
        React.createElement("path", { d: "M13.5355 13.5355L6.46442 6.46445", fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } })));
};
//# sourceMappingURL=Cross.js.map